exports.list = {
    path: '/pencairan_cek_terima',
    name: 'pencairan_cek_terima', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pencairan_cek_terima/List.vue"),
}
exports.show = {
    path: '/pencairan_cek_terima/show/:no_kk',
    name: 'pencairan_cek_terima_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pencairan_cek_terima/Show.vue"),
}